
export default function HowToApply() {
  const steps = [
    {
      step: 1,
      title: '公式サイトにアクセス',
      description: '下のボタンからジャックス Gold Time公式サイトにアクセスします。',
      icon: 'ri-global-line',
    },
    {
      step: 2,
      title: '申込フォームに入力',
      description: '氏名、住所、勤務先情報などの必要事項を入力します。',
      icon: 'ri-edit-line',
    },
    {
      step: 3,
      title: '本人確認書類の提出',
      description: '運転免許証やマイナンバーカードなどの本人確認書類をアップロードします。',
      icon: 'ri-file-user-line',
    },
    {
      step: 4,
      title: '審査',
      description: 'ジャックスにて審査が行われます。審査結果はメールで通知されます。',
      icon: 'ri-search-line',
    },
    {
      step: 5,
      title: '口座設定',
      description: '引き落とし口座の設定を行います。オンラインで完結できます。',
      icon: 'ri-bank-line',
    },
    {
      step: 6,
      title: 'カード発行・郵送',
      description: '審査通過後、カードが発行され、ご自宅に届きます。届いたらすぐに利用開始できます。',
      icon: 'ri-mail-send-line',
    },
  ];

  const documents = [
    '運転免許証',
    'マイナンバーカード（個人番号カード）',
    'パスポート',
    '健康保険証',
    '住民票の写し',
  ];

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-3 text-center">
          ジャックス Gold Timeの申込み方法
        </h2>
        <p className="text-gray-600 text-center mb-12">オンラインで簡単に申し込めます</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md p-6 relative">
              <div className="absolute -top-3 -left-3 w-8 h-8 flex items-center justify-center bg-gradient-to-r from-[#C9A227] to-[#E8D48B] rounded-full text-[#1A1A2E] font-bold text-sm">
                {step.step}
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-[#1A1A2E] rounded-full mb-4 mx-auto">
                <i className={`${step.icon} text-[#E8D48B] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A1A2E] text-center mb-2">{step.title}</h3>
              <p className="text-gray-600 text-sm text-center">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
          <h3 className="text-xl font-bold text-[#1A1A2E] mb-6 flex items-center gap-2">
            <i className="ri-file-list-3-line text-[#C9A227]"></i>
            必要書類
          </h3>
          <p className="text-gray-600 text-sm mb-4">以下のいずれか1点をご用意ください：</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {documents.map((doc, index) => (
              <div key={index} className="flex items-center gap-2 bg-[#F8F9FA] rounded-lg px-4 py-3">
                <i className="ri-checkbox-circle-fill text-[#4CAF50]"></i>
                <span className="text-gray-700 text-sm">{doc}</span>
              </div>
            ))}
          </div>
          <p className="text-gray-500 text-xs mt-4">
            ※キャッシング枠をご希望の場合は、収入証明書類が必要になる場合があります。
          </p>
        </div>
      </div>
    </section>
  );
}
